<script setup lang="ts"></script>

<template>
	<p class="mt-2 text-sm text-message-error">
		<slot></slot>
	</p>
</template>

<style scoped></style>
